var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_c('span',{staticClass:"w-4 h-4 flex-shrink-0 rounded-full border-4 mr-1",class:_vm.borderClass}),_c('span',[_vm._v(_vm._s(_vm.style.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }